export default "__VITE_ASSET__D8TkSMKr__"